<template>
    <div class="index">
        <back-to-top-component/>
        <home-header :onlyShowTop="true"/>

        <img src="../assets/imgs/img2.jpg" >
<!--        <home-body/>-->
        <home-footer/>
      <!--  <home-footer/>-->
    </div>
</template>

<script>
    import HomeHeader from "./home/HomeHeader";
    import HomeFooter from "./home/HomeFooter";
    import HomeBody from "./home/HomeBody"
    import BackToTopComponent from "../components/BackToTopComponent"
    export default {
        name: 'HomeIndex',
        components:{ HomeHeader,HomeBody,HomeFooter,BackToTopComponent},
        data() {
            return {

            }
        }
    }
</script>

<style scoped lang="stylus">
  .index{
    background-color :#f9f9f9
  }
</style>
